import React, { useState, useEffect } from 'react';
import { useFileContext } from '../../ContextAPI/FileContext';
import './ToggleSwitch.css';
import { ManagerlApi } from '../../API/api';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { FaTrash } from 'react-icons/fa';

const PSDClassificationTab = () => {
  const { isPSDClassificationEnabled, setIsPSDClassificationEnabled, setRunPSDClassification } =
    useFileContext();
  const [parameters, setParameters] = useState({
    db: '',
    collection: '',
  });
  const [showCheckMark, setShowCheckMark] = useState(false);
  const [requests, setRequests] = useState([]);


  const getFormattedTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleRunPSDClassification = async () => {
    const apiUrl = `${ManagerlApi}/PSD-Classification`;
    console.log(apiUrl);

    setShowCheckMark(false);
    setTimeout(() => {
      setShowCheckMark(true);
      setTimeout(() => setShowCheckMark(false), 6000);
    }, 100);

    const startTime = getFormattedTime();
    const requestId = uuidv4();
    setRequests((prevRequests) => [
      ...prevRequests,
      { id: requestId, status: 'Sent', startTime, parameters },
    ]);

    try {
      const response = await axios.post(apiUrl, parameters, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const statusMessage = response.data.message || 'Task Completed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${statusMessage} ✅` }
            : request
        )
      );
    } catch (error) {
      console.error('Error during PSD Classification!', error);

      const errorMessage = error.response?.data?.message || 'Task Failed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${errorMessage} ❌` }
            : request
        )
      );
    }
  };

  const handleParameterChange = (e) => {
    const { name, value } = e.target;
    setParameters((prevParams) => ({
      ...prevParams,
      [name]: value,
    }));
  };

  const handleDeleteRequest = (id) => {
    setRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== id)
    );
  };

  const handleClearAll = () => {
    setRequests([]);
  };

  useEffect(() => {
    setRunPSDClassification(() => handleRunPSDClassification);
  }, [parameters, setRunPSDClassification]);

  return (
    <div>
      <div>
        <label>Database</label>
        <input
          type='text'
          name='db'
          placeholder='MongoDB database'
          value={parameters.db}
          onChange={handleParameterChange}
        />
      </div>
      <div>
        <label>Collection</label>
        <input
          type='text'
          name='collection'
          placeholder='MongoDB collection'
          value={parameters.collection}
          onChange={handleParameterChange}
        />
      </div>
      <div>
        <button onClick={handleRunPSDClassification}>
          Run PSD Classification
        </button>
      </div>
      {showCheckMark && (
        <div className='check-mark'>Request Sent ✅</div>
      )}
      <div className='request-list'>
        <table>
          <thead>
            <tr>
              <th>Request ID</th>
              <th>Status</th>
              <th>Start Time</th>
              <th>Parameters</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <React.Fragment key={request.id}>
                <tr>
                  <td>{request.id}</td>
                  <td>{request.status}</td>
                  <td>{request.startTime}</td>
                  <td>
                    <pre>{JSON.stringify(request.parameters, null, 2)}</pre>
                  </td>
                  <td>
                    <button onClick={() => handleDeleteRequest(request.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <button className='clear-all-button' onClick={handleClearAll}>
          Remove All
        </button>
      </div>
    </div>
  );
};

export default PSDClassificationTab;
